export default {
  questions: [],
  listLoading: true
}
